import { render, staticRenderFns } from "./OushiDiaoxianItem.vue?vue&type=template&id=2aef58e9&scoped=true&"
import script from "./OushiDiaoxianItem.vue?vue&type=script&lang=js&"
export * from "./OushiDiaoxianItem.vue?vue&type=script&lang=js&"
import style0 from "./OushiDiaoxianItem.vue?vue&type=style&index=0&id=2aef58e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef58e9",
  null
  
)

export default component.exports